import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TextInput } from 'evergreen-ui';
import { Link } from 'react-router';
import { lng } from './js/language.js';

function Contacts() {

    const sectionContacts = useRef(null);
    const location = useLocation();
    const {hash} = location;
    const defaultForm = {
        name: '',
        mail: '',
        phone: '',
        enquiry: ''
    };
    const [contactForm, setContactForm] = useState(defaultForm);
    const [errorName, setErrorName] = useState('');
    const [errorMail, setErrorMail] = useState('');
    const [errorEnquiry, setErrorEnquiry] = useState('');
    const [alert, setAlert] = useState({
        status: '',
        msg: ''
    });

    function handleAlert() {
        setAlert({
            ...alert,
            status: '',
            msg: ''
        });
    }

     useEffect(() => {
        if (hash === '#contacts') {      
            window.scrollTo({
                top: sectionContacts.current.offsetTop,
                behavior: "smooth",
            });
        }
        window.addEventListener('scroll', handleAlert);
        return () => {
            window.removeEventListener('scroll', handleAlert);
        };
    }, [hash, sectionContacts]);

    const [currentLangObj, setCurrentLangObj] = useState(lng[localStorage.getItem('currentLang') || 'bg']);
    function handleCheckLang() {
        setCurrentLangObj(lng[localStorage.getItem('currentLang') || 'bg']);
    }
    useEffect(() => {
        window.addEventListener('click', handleCheckLang);
        return () => {
            window.removeEventListener('click', handleCheckLang);
        };
    }, []);

    function validateEmail(email) {
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        return emailReg.test( email ) && email;
    }

    function changeContactFormValues(e) {
        setContactForm({
            ...contactForm,
            [e.target.name]: e.target.value
        });
    }

    function viladateContactForm() {
        let error = 0;
        setErrorName('');
        setErrorMail('');
        setErrorEnquiry('');
        if (!contactForm.name || contactForm.name.length < 3) {
            setErrorName(currentLangObj.errName);
            error = error + 1;
        }
        if (!contactForm.mail || !validateEmail(contactForm.mail)) {
            setErrorMail(currentLangObj.errEmail);
            error = error + 1;
        }
        if (!contactForm.enquiry || contactForm.enquiry.length < 10) {
            setErrorEnquiry(currentLangObj.errInquire);
            error = error + 1;
        }
        if (!error) {
            return true;
        }
        return false;
    }

    function setContactInfo() {
        if (viladateContactForm()) {
            fetch('https://vekotasoft.com/setContactMsg', {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify(contactForm)
            })
            .then(() => {
                console.log('sent email');
                setAlert({
                    ...alert,
                    status: 'success',
                    msg: currentLangObj.sentSuccess
                });
                setContactForm({
                    ...contactForm,
                    name: '',
                    mail: '',
                    phone: '',
                    enquiry: ''
                });
                // const timer = setTimeout(() => console.log('Initial timeout!'), 5000);
                // clearTimeout(timer);      
            })
            .catch((error) => {
                console.log('error');
            });
        }
    }

    return (
        <section className="trust" id="contacts" ref={sectionContacts}>
            <div className="container">
                <div className="row contact-row">
                    <div className="col-md-6">
                        <div className="title">
                            <h6 className="title-primary suggestions">{currentLangObj.suggestions}</h6>
                            <h2 className="touch">{currentLangObj.touch}</h2>
                        </div>
                        <p className="use-contact">
                            <elem dangerouslySetInnerHTML={{ __html: currentLangObj.useContact}} />
                        </p>

                        <h6 className="follow-us centered">{currentLangObj.followUs}</h6>
                        <div className="media-element  justify-content-between">
                            <div className="media contact-media">
                                <Link to="https://www.facebook.com/profile.php?id=61579028421219"  target="_blank">
                                    <i className="fa fa-facebook"></i>
                                </Link>
                                <Link to="https://www.instagram.com/vekotasoft" target="_blank">
                                    <i className="fa fa-instagram"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <form method="post" action="/#contacts" className="col-md-6" id="form-contact">
                        <div className="form-group required">
                            <label className="your-name">{currentLangObj.yourName} *</label>
                            <TextInput id="name" name="name" onChange={(e) => changeContactFormValues(e)} className="form-control text-field" value={contactForm.name} required />
                            <div className="text-danger" id="danger-name">{errorName}</div>
                        </div>
                        <div className="form-group  required">
                            <label>Email *</label>
                            <TextInput id="mail" name="mail" onChange={(e) => changeContactFormValues(e)} className="form-control text-field" value={contactForm.mail} required />
                            <div className="text-danger" id="danger-mail">{errorMail}</div>
                        </div>
                        <div className="form-group">
                            <label className="phone">{currentLangObj.phone}</label>
                            <TextInput id="phone" name="phone" onChange={(e) => changeContactFormValues(e)} className="form-control text-field" value={contactForm.phone} />
                        </div>
                        <div className="form-group required">
                            <label className="inquiry">{currentLangObj.inquiry} *</label>
                            <textarea name="enquiry" autoComplete="off" className="form-control" id="enquiry"
                                rows="5" onChange={(e) => changeContactFormValues(e)} value={contactForm.enquiry} />
                            <div className="text-danger" id="danger-enquiry">{errorEnquiry}</div>
                        </div>
                        <Link to="#" className="btn btn-primary btn-one btn-contact-form" onClick={setContactInfo}>
                            {currentLangObj.send}
                        </Link>
                    </form>
                </div>
                <div className={`alert alert-${alert.status} alert-dismissible fade show sent-message`}>
                    {alert.msg}
                </div>  
            </div>

        </section>
    );
}

export default Contacts;